// [PROD] Manday 2025
export const sheetUrl = 'https://api.sheetbest.com/sheets/a9828eb2-3446-4bae-98cf-6e8351912fee'
// [PROD] Day Off 2025
export const leaveSheetUrl = 'https://api.sheetbest.com/sheets/b0a83ca5-d913-435c-91fb-01dd7355d50e'

// [PROD] White board Sheet
export const whiteBoardSheetUrl = 'https://sheet.best/api/sheets/bfc697e3-4986-4ee4-9e92-ddbb9200110f'

export const trackingUrl = 'https://tracking.ksta.co/'
export const secretPass = 'password1234'

export const middleware = 'https://tracking-notify.ksta.co/sheet'

// [PROD]
// export const api_base = 'https://102lpmjr-3000.asse.devtunnels.ms/'
export const api_base = 'https://tracking-notify.ksta.co/'

// key must be 64 char
export const encryptionKey = 'mNGp6fxDgU4fZXMwtCNBGfLUnNlH7bIuNoOqVFIOZlm3vb4dePWQYGyqcks67Q4m'


